import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { i18nDateToString } from 'modules/core/lib/dates'

import { useDateBookingContext } from 'modules/space_control/components/dateBookingContext'
import { WorkAreaMapLocationNode } from 'modules/space_control/hooks/useWorkAreaMap'

interface UseUserMapEventsProps {
  workSpaceLocations: WorkAreaMapLocationNode[]
}

export const useUserMapEvents = ({ workSpaceLocations }: UseUserMapEventsProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const spaceControl = useDateBookingContext()

  const handleSpaceClick = useCallback(
    ({ workAreaMapLocation }: { workAreaMapLocation: WorkAreaMapLocationNode | null }) => {
      if (!workAreaMapLocation?.workSpace?.id) return

      track(trackingEvents.spaceControl.bookings.addBooking, {
        type_space: workAreaMapLocation?.workSpace?.workSpaceTypeName,
        capacity: workAreaMapLocation?.workSpace?.capacity,
      })
      navigate(
        navigation.spaceControl.overview.booking.fullPath({
          date: i18nDateToString(spaceControl.date, 'backend'),
          workSpaceId: workAreaMapLocation?.workSpace?.id?.toString() || '',
        })
      )
    },
    [workSpaceLocations, navigate, navigation, spaceControl.date]
  )

  const handleMapClick = useCallback((_coordinates: { x: number; y: number }) => {}, [])

  return {
    actions: {
      onPinClick: handleSpaceClick,
      onMapClick: handleMapClick,
    },
  }
}
